import { REPORT_ENDPOINT } from '../../../../../api/endpoint';
export const NATIONALITY_FORECAST_REPORT_ENDPOINT = `${REPORT_ENDPOINT}/nationality_forecast`;
